import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { OrderItemAskForOrderIdError } from '@infrastructure/order-item-ask-for-order-id-error';
import { SubscribingComponent } from '@infrastructure/subscribing-component';
import { OrderChooserModalComponent } from '@modals/order-chooser-modal/order-chooser-modal.component';
import { CustomizerMenuPartModel } from '@models/customizer-menu-part';
import { MiscModel } from '@models/misc-model';
import { OrderItemMiscModel } from '@models/order-item-misc-model';
import { OrderItemMiscType } from '@models/order-item-misc-type';
import { TranslatePipe } from '@ngx-translate/core';
import { ImageService } from '@services/image.service';
import { ModalService } from '@services/modal.service';
import { OrderService } from '@services/order.service';
import { AddToBagButtonComponent } from '../add-to-bag-button/add-to-bag-button.component';
import { CustomizerComponentHeaderComponent } from '../customizer-component-header/customizer-component-header';

@Component({
	selector: 'customizer-upselling',
	templateUrl: 'customizer-upselling.html',
	styleUrls: ['./customizer-upselling.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CustomizerComponentHeaderComponent, AddToBagButtonComponent, TranslatePipe]
})
export class CustomizerUpsellingComponent extends SubscribingComponent {

	@Input() miscModel: MiscModel | null;
	@Input() menu: CustomizerMenuPartModel;
	@Input() reference: string;
	@Output() clicked: EventEmitter<void> = new EventEmitter();

	private orderSelectEmitter = new EventEmitter<number>();
	private orderId: number | null = null;

	constructor(public imageService: ImageService, private addtobagService: OrderService, private modalService: ModalService) {
		super();
		this.subscriptions.push(this.orderSelectEmitter.subscribe(async (selectedOrderId) => {
			this.orderId = selectedOrderId;
			await this.addTobag(selectedOrderId === null);
			this.orderId = null;
		}));
	}

	public async addTobag(newOrderSelected?: boolean) {
		try {
			const orderMiscItemModel = OrderItemMiscModel.Create(
				this.orderId,
				this.reference,
				1,
				undefined,
				false,
				null,
				false,
				OrderItemMiscType.StockKeepingUnit,
				undefined,
				null,
				this.miscModel);
			await this.addtobagService.AddMiscToBag(orderMiscItemModel, newOrderSelected);
			this.clicked.emit();
		} catch (error) {
			if (error instanceof OrderItemAskForOrderIdError) {
				this.modalService.create(OrderChooserModalComponent, { orderSelect: this.orderSelectEmitter });
			} else {
				throw error;
			}
		}
	}

	public async dontAdd() {
		this.miscModel = null;
		this.clicked.emit();
	}

}
